import { Theme } from '@mui/material';

const Table = (theme: Theme) => {
  return {
  };
};

export default Table;
